<script setup>
// import { RouterView } from "vue-router";
</script>

<template>
    <Toast />
    <RouterView />
    <vue-progress-bar></vue-progress-bar>
</template>

<style scoped></style>
